import { Box, Link as MuiLink, Stack, Typography } from "@mui/material"
import React from "react"
import { CompanyDetails } from "src/components/CompanyDetails"
import { Footer } from "src/components/Footer"

export default function TermsOfServicePage() {
  return (
    <>
      <Stack gap={2}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight={500}>
          Terms of Service
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ color: "text.secondary", fontStyle: "italic" }}
          gutterBottom
        >
          Last updated: June 23, 2025
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1">
          By accessing or using{" "}
          <MuiLink href="https://privatefolio.xyz" target="_blank" rel="noopener">
            privatefolio.xyz
          </MuiLink>{" "}
          or{" "}
          <MuiLink href="https://privatefolio.app" target="_blank" rel="noopener">
            privatefolio.app
          </MuiLink>{" "}
          (the “Service”), you agree to these Terms. If you disagree, do not use the Service.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          2. Description of Service
        </Typography>
        <Typography variant="body1">
          Privatefolio provides a personal portfolio hosting and management platform. We may modify
          or discontinue features at any time.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          3. User Accounts
        </Typography>
        <Box component="ul" sx={{ "&&": { mt: 0 }, pl: 4 }}>
          <li>
            <Typography variant="body1">
              You must register with a valid email and password.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              You&apos;re responsible for account security and activity.
            </Typography>
          </li>
        </Box>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          4. Acceptable Use
        </Typography>
        <Typography variant="body1">You agree not to:</Typography>
        <Box component="ul" sx={{ "&&": { mt: 0 }, pl: 4 }}>
          <li>
            <Typography variant="body1">Violate laws or third-party rights.</Typography>
          </li>
          <li>
            <Typography variant="body1">Upload harmful, infringing, or abusive content.</Typography>
          </li>
          <li>
            <Typography variant="body1">Interfere with Service operation or security.</Typography>
          </li>
        </Box>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          5. User Content
        </Typography>
        <Box component="ul" sx={{ "&&": { mt: 0 }, pl: 4 }}>
          <li>
            <Typography variant="body1">You retain ownership of what you post.</Typography>
          </li>
          <li>
            <Typography variant="body1">
              You grant us a royalty-free license to display and distribute it as needed to operate
              the Service.
            </Typography>
          </li>
        </Box>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          6. Intellectual Property
        </Typography>
        <Typography variant="body1">
          All Service content (software, designs, trademarks) is owned by Privatefolio or licensors.
          You may not copy or use it without permission.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          7. Termination
        </Typography>
        <Typography variant="body1">
          We may suspend or terminate your account for violations or inactivity. You can delete your
          account at any time; residual data may persist per our Privacy Policy.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          8. Disclaimers &amp; Limitation of Liability
        </Typography>
        <Box component="ul" sx={{ "&&": { mt: 0 }, pl: 4 }}>
          <li>
            <Typography variant="body1">
              The Service is provided &quot;as-is&quot; without warranties.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              We&apos;re not liable for damages arising from your use, to the maximum extent
              permitted by law.
            </Typography>
          </li>
        </Box>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          9. Third-Party Links &amp; Services
        </Typography>
        <Typography variant="body1">
          We&apos;re not responsible for external sites or integrations. Review their terms before
          use.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          10. Modifications to Terms
        </Typography>
        <Typography variant="body1">
          We may update these Terms; we&apos;ll post changes here with a new &quot;Last
          updated&quot; date. Continued use constitutes acceptance.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          11. Governing Law
        </Typography>
        <Typography variant="body1">
          These Terms are governed by the laws of Romania and the European Union, excluding
          conflict-of-law rules.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
          12. Contact Us
        </Typography>
        <Typography variant="body1" component="div">
          <b>Email:</b>{" "}
          <MuiLink href="mailto:hello@danielconstantin.net" underline="hover">
            hello@danielconstantin.net
          </MuiLink>
          <br />
          <br />
          <CompanyDetails />
        </Typography>
      </Stack>
      <Footer />
    </>
  )
}
